import { graphql } from 'ms-client/graphql/user-pool'

const sendEmailMutation = /* GraphQL */ `
  mutation SendEmail($to: [String!]!, $subject: String!, $content: String!) {
    sendEmail(to: $to, subject: $subject, content: $content)
  }
`

export async function send(subject: string, content: string, to: string[]) {
  const data = await graphql<any, any>({
    query: sendEmailMutation,
    variables: {
      subject,
      content,
      to
    }
  })

  return data.sendEmail
}
